/**
 * Court Connect partner form — a thin wrapper over the schema-driven
 * <LeadForm> (src/forms/definitions/courtConnectPartner.jsx). Lands in the
 * Partner layout, tagged "Court Connect".
 */
import LeadForm from "@/forms/engine/LeadForm";
import { LottieSuccess } from "@/components/LottieAnimations";
import courtConnectPartner from "@/forms/definitions/courtConnectPartner";

const CONTEXT = {
  campaign: "Court Connect",
  follow_up: "Website, current payment setup and notes deferred to follow-up call.",
};

function SuccessMessage() {
  return (
    <div className="text-center py-12 space-y-4" data-testid="cc-form-success" role="status">
      <LottieSuccess size={80} className="mx-auto" />
      <h3 className="font-heading text-2xl font-bold text-brand-black">{courtConnectPartner.success.title}</h3>
      <p className="text-brand-grey">{courtConnectPartner.success.body}</p>
    </div>
  );
}

export default function CourtConnectPartnerForm() {
  return (
    <LeadForm schema={courtConnectPartner} context={CONTEXT} renderSuccess={() => <SuccessMessage />} />
  );
}
